import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { ENVIRONMENT } from '@env/environment';

type ClarityFn = (...args: unknown[]) => void;

interface ClarityQueueFn extends ClarityFn {
  q?: unknown[][];
}

interface WindowWithClarity extends Window {
  clarity?: ClarityQueueFn;
}

@Injectable()
export class ClarityService {
  readonly #document = inject(DOCUMENT);

  init(): void {
    if (!ENVIRONMENT.clarity?.enabled || !ENVIRONMENT.clarity?.projectId) {
      return;
    }

    const windowWithClarity = window as WindowWithClarity;

    windowWithClarity.clarity =
      windowWithClarity.clarity ??
      ((...args: unknown[]): void => {
        const clarityFn = windowWithClarity.clarity;
        if (!clarityFn) {
          return;
        }

        clarityFn.q = clarityFn.q ?? [];
        clarityFn.q.push(args);
      });

    const script = this.#document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${ENVIRONMENT.clarity.projectId}`;

    const firstScript = this.#document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  }
}
